import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import API_ENDPOINTS from '../api/apiConfig';

function JoinPartner() {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: '',
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError('');
        setSuccess('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');

        try {
            const response = await fetch(API_ENDPOINTS.CREATEPARTNERREQUEST, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(formData),
            });

            const data = await response.json();

            if (data.status) {
                setSuccess('Thank you! Your partner request has been submitted. We will contact you shortly.');
                setFormData({ name: '', email: '', phone: '', message: '' });
            } else {
                setError(data.message || 'Something went wrong. Please try again.');
            }
        } catch (err) {
            setError('Network error. Please check your connection and try again.');
        } finally {
            setLoading(false);
        }
    };

    const icons = [
        { icon: '🤝', label1: 'Mutual', label2: 'Growth' },
        { icon: '📈', label1: 'Business', label2: 'Expansion' },
        { icon: '🛡️', label1: 'Trusted', label2: 'Partnership' },
        { icon: '👥', label1: 'Long Term', label2: 'Success' },
    ];

    const inputStyle = {
        width: '100%', padding: '11px 14px', fontSize: '14px',
        border: '1.5px solid #e0d9f7', borderRadius: '8px',
        outline: 'none', boxSizing: 'border-box',
        backgroundColor: '#fafafa',
    };

    return (
        <>
            {/* ===== BANNER ===== */}
            <div style={{
                backgroundImage: "url('/img/about/join-partner.webp')",
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                width: '100%',
                minHeight: '420px',
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
            }}>
                <div style={{ position: 'absolute', inset: 0, backgroundColor: 'rgba(10, 15, 50, 0.65)' }} />
                <div style={{
                    position: 'relative', zIndex: 1, width: '100%', maxWidth: '1200px',
                    margin: '0 auto', padding: '60px 30px 40px',
                    display: 'flex', justifyContent: 'space-between',
                    alignItems: 'center', flexWrap: 'wrap', gap: '40px',
                }}>
                    <div style={{ flex: '1', minWidth: '280px' }}>
                        <h1 style={{ color: '#fff', fontSize: '42px', fontWeight: '700', margin: '0 0 4px' }}>Join Us</h1>
                        <h2 style={{ color: '#7b5ff5', fontSize: '42px', fontWeight: '700', margin: '0 0 12px' }}>As Partner</h2>
                        <div style={{ width: '60px', height: '3px', backgroundColor: '#7b5ff5', marginBottom: '20px' }} />
                        <p style={{ color: '#ddd', fontSize: '16px', margin: '0 0 4px' }}>Grow together. Succeed together.</p>
                        <p style={{ color: '#ddd', fontSize: '16px', margin: '0 0 36px' }}>Build lasting partnerships for a stronger tomorrow.</p>
                        <div style={{ display: 'flex', gap: '24px', flexWrap: 'wrap' }}>
                            {icons.map((item, index) => (
                                <div key={index} style={{ textAlign: 'center' }}>
                                    <div style={{
                                        width: '70px', height: '70px', borderRadius: '50%',
                                        backgroundColor: '#6c47d9', display: 'flex',
                                        alignItems: 'center', justifyContent: 'center',
                                        fontSize: '28px', marginBottom: '10px',
                                    }}>{item.icon}</div>
                                    <p style={{ color: '#fff', fontSize: '13px', margin: 0, lineHeight: '1.4' }}>
                                        {item.label1}<br />{item.label2}
                                    </p>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div style={{ textAlign: 'center', minWidth: '200px' }}>
                        <h3 style={{ color: '#fff', fontSize: '28px', fontWeight: '600', marginBottom: '12px' }}>Join Us As Partner</h3>
                        <div style={{ display: 'flex', justifyContent: 'center', gap: '8px', alignItems: 'center' }}>
                            <Link to="/" style={{ color: '#ccc', textDecoration: 'none', fontSize: '15px' }}>Home</Link>
                            <span style={{ color: '#ccc', fontSize: '15px' }}>/ Join us</span>
                        </div>
                    </div>
                </div>
            </div>

            {/* ===== PARTNER SECTION ===== */}
            <section style={{ backgroundColor: '#f9f9ff', padding: '70px 20px' }}>
                <div style={{ maxWidth: '1100px', margin: '0 auto', display: 'flex', gap: '50px', flexWrap: 'wrap', alignItems: 'flex-start' }}>

                    {/* Left - Description */}
                    <div style={{ flex: '1', minWidth: '280px' }}>
                        <h2 style={{ fontSize: '32px', color: '#1a1a2e', fontWeight: '700', marginBottom: '16px' }}>
                            Become Our <span style={{ color: '#6c47d9' }}>Trusted Partner</span>
                        </h2>
                        <div style={{ width: '50px', height: '3px', backgroundColor: '#6c47d9', marginBottom: '20px' }} />
                        <p style={{ color: '#555', fontSize: '15px', lineHeight: '1.8', marginBottom: '16px' }}>
                            Join our growing network of financial partners and unlock new opportunities for growth.
                            Whether you are an individual agent, a financial consultant, or a business entity —
                            we welcome you to be a part of the <strong>Vijay Primes</strong> family.
                        </p>
                        <p style={{ color: '#555', fontSize: '15px', lineHeight: '1.8', marginBottom: '24px' }}>
                            As our partner, you will get access to exclusive loan and insurance products,
                            dedicated support, attractive commissions, and a wide range of tools to help
                            your clients get the best financial solutions.
                        </p>
                        {[
                            '💰 Earn attractive commissions on every successful referral',
                            '📊 Access to a wide range of loan & insurance products',
                            '🤝 Dedicated relationship manager for your support',
                            '📱 Real-time tracking of your leads and earnings',
                            '🏆 Recognition and rewards for top-performing partners',
                        ].map((point, i) => (
                            <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', marginBottom: '12px' }}>
                                <p style={{ color: '#444', fontSize: '14px', margin: 0, lineHeight: '1.6' }}>{point}</p>
                            </div>
                        ))}
                    </div>

                    {/* Right - Form */}
                    <div style={{
                        flex: '1', minWidth: '300px', backgroundColor: '#fff',
                        borderRadius: '12px', padding: '40px 32px',
                        boxShadow: '0 4px 24px rgba(108,71,217,0.10)',
                    }}>
                        <h3 style={{ fontSize: '22px', color: '#1a1a2e', fontWeight: '700', marginBottom: '6px' }}>
                            Partner Inquiry Form
                        </h3>
                        <p style={{ color: '#888', fontSize: '14px', marginBottom: '24px' }}>
                            Fill in your details and our team will get back to you within 24 hours.
                        </p>

                        {/* Success Message */}
                        {success && (
                            <div style={{
                                backgroundColor: '#f0fdf4', border: '1px solid #86efac',
                                borderRadius: '8px', padding: '12px 16px',
                                color: '#166534', fontSize: '14px', marginBottom: '16px',
                            }}>
                                ✅ {success}
                            </div>
                        )}

                        {/* Error Message */}
                        {error && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fca5a5',
                                borderRadius: '8px', padding: '12px 16px',
                                color: '#991b1b', fontSize: '14px', marginBottom: '16px',
                            }}>
                                ❌ {error}
                            </div>
                        )}

                        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                            <div>
                                <label style={{ fontSize: '13px', fontWeight: '600', color: '#444', display: 'block', marginBottom: '6px' }}>
                                    Full Name <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input type="text" name="name" value={formData.name}
                                    onChange={handleChange} placeholder="Enter your full name"
                                    style={inputStyle} />
                            </div>

                            <div>
                                <label style={{ fontSize: '13px', fontWeight: '600', color: '#444', display: 'block', marginBottom: '6px' }}>
                                    Email Address <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input type="email" name="email" value={formData.email}
                                    onChange={handleChange} placeholder="Enter your email"
                                    style={inputStyle} />
                            </div>

                            <div>
                                <label style={{ fontSize: '13px', fontWeight: '600', color: '#444', display: 'block', marginBottom: '6px' }}>
                                    Phone Number <span style={{ color: 'red' }}>*</span>
                                </label>
                                <input type="tel" name="phone" value={formData.phone}
                                    onChange={handleChange} placeholder="Enter your phone number"
                                    style={inputStyle} />
                            </div>

                            <div>
                                <label style={{ fontSize: '13px', fontWeight: '600', color: '#444', display: 'block', marginBottom: '6px' }}>
                                    Message
                                </label>
                                <textarea name="message" value={formData.message}
                                    onChange={handleChange}
                                    placeholder="Tell us about yourself or your business..."
                                    rows={4}
                                    style={{ ...inputStyle, resize: 'vertical' }} />
                            </div>

                            <button
                                onClick={handleSubmit}
                                disabled={loading}
                                style={{
                                    backgroundColor: loading ? '#a78bdc' : '#6c47d9',
                                    color: '#fff', border: 'none', borderRadius: '8px',
                                    padding: '13px', fontSize: '15px', fontWeight: '600',
                                    cursor: loading ? 'not-allowed' : 'pointer',
                                    marginTop: '4px', transition: 'background 0.2s',
                                }}
                                onMouseOver={e => { if (!loading) e.target.style.backgroundColor = '#5535b8'; }}
                                onMouseOut={e => { if (!loading) e.target.style.backgroundColor = '#6c47d9'; }}
                            >
                                {loading ? 'Submitting...' : 'Submit Partner Request'}
                            </button>
                        </div>
                    </div>

                </div>
            </section>
        </>
    );
}

export default JoinPartner;